export default __webpack_public_path__ + "static/identity-mock-m-3aa86acf74e1203720874eefae49dd18.png";